import { useEffect } from "react";
import styles from "./styles.module.scss";

/** Injects new public page typography styles to document body. */
export function TypographyWrapper(props: { children?: React.ReactNode }) {
  useEffect(() => {
    // Add the typography styles to the document body
    document.body.classList.add(styles.typography);

    // Cleanup function to remove the styles when the component unmounts
    return () => {
      document.body.classList.remove(styles.typography);
    };
  }, []);

  return <>{props.children}</>;
}
